import React, { useState } from "react";
// api services
import apiParticipantes from "../api/Participantes/api-participantes";
import { openNotification } from '../utils/Notifactions';
import DocumentosService from "../api/Documentos/api-documentos";
import getStorageUser from "../middlewares/GetStorageUser"

import axios from 'axios'

export const useSubsanarBeps = () => {
    const [, setPostulacionState] = useState<any>({});
    const [totalregistros, setTotalregistros] = useState<number>(0);
    const [cantidadpáginas, setCantidadPáginas] = useState<number>(10);
    // subsanar documentos
    const [documentos, setDocumentos] = useState<any>([]);
    const [documentossubsanar, setDocumentosSubsanar] = useState<any>([]);
    const [totaldocumentossubsanar, setTotalDocumentosSubsanar] = useState<number>(0);
    const [cantidadpáginassubsanar, setCantidadPáginasSubsanar] = useState<number>(10);

    const cargarPostulaciones = async () => {
        const user = getStorageUser()
        //let { data } = await apiParticipantes.obtenerPostulacionesBepsDocumento(user.documento);

        // const { data } = await axios.get(`${process.env.REACT_APP_SERVER_PART}postulaciones/consultarPostulacionesBesp/${user.documento}`);

        const token = localStorage.getItem('token')
        const { data } = await axios.get(`${process.env.REACT_APP_SERVER_PART}postulaciones/consultarDocumentosAdministrativosBeps/${user.documento}`, {
            headers: {
                'Authorization': token
            }
        });
        
        if(data.data.length > 0){
            setDocumentos(data.data)
            setTotalregistros(data.data.length);
            setTotalDocumentosSubsanar(data.data.length);
            const documentosASubsanar = data.data.filter((item: any) => item.estado == "Subsanar")
            //console.log(documentosASubsanar, 'claro que hay')
            return setDocumentosSubsanar(documentosASubsanar);
        }else{
            return setDocumentosSubsanar([]);
        }
        
        // let subsanar = data.postulacionesBeps.filter((data: any) => data.estado === "Subsanar");
        // var documentos: any = [];
        // let contador: number = 0
        // if (subsanar.length > 0) {
        //     subsanar.map((item: any) => {
        //         item.documentos_administrativos.map((item2: any) => {
        //             if (!item2.tipo_documento) item2.tipo_documento = item2.descripcion;
        //             documentos = [
        //                 ...documentos,
        //                 {
        //                     ...item,
        //                     ...item2,
        //                 },
        //             ];
        //             contador++
        //         });
        //     });
        // }
        
        // documentos = documentos.filter((data: any) => data.checksubsanable);
        // console.log(documentos, 'esto es lo que se setea')
        
        
    };
    const guardarArchivosAdministrativos = async (datos: any, e: any, index: number) => {
        try {
            if (e.target.files[0].size > 5000000) {
                return openNotification({
                    titulo: "Error",
                    descripcion: "Solo se permiten archivos menores a 5MB",
                    placement: "bottomRight",
                });
            }
            const formData = new FormData();
            formData.append("archivo", e.target.files[0]);
            const resp = await DocumentosService.guardarArchivo(formData);

            if(resp.ok){
                documentossubsanar[index].estado = "Subsanado";
                documentossubsanar[index].url_participante = resp.data;
                documentossubsanar[index].checksubsanado =  true;
                documentossubsanar[index].checksubsanable = false;
                documentossubsanar[index].checkaceptar = false;
                documentossubsanar[index].checkcancelar = false;    
                let id_postulacion = documentossubsanar[index].id_postulacion;
                const documentosUpdate = documentos.filter( (item: any) => item.id_postulacion == id_postulacion)
                apiParticipantes.guardarDocumentosAdministrativosBeps(id_postulacion, documentosUpdate )
                return setDocumentosSubsanar(documentossubsanar);
                // return setDocumentosSubsanar({...documentossubsanar, documentossubsanar[index] })
            }else{
                return openNotification({
                    titulo: "Error",
                    descripcion: "Error al cargar el archivo porfavor intentelo mas tarde.",
                    placement: "bottomRight",
                });
            }

        //    console.log(documentossubsanar)
            // let nuevosdocumentos: any = documentossubsanar.map((doc: any, indexdoc: number) => {
            //     if (!doc.tipo_documento) doc.tipo_documento = doc.descripcion;
            //     if (datos.tipo_documento === doc.tipo_documento) {
            //         return {
            //             ...doc,
            //             url_participante: name,
            //             checksubsanable: false,
            //             checksubsanado: true,
            //         };
            //     }
            //     return {
            //         ...doc,
            //     };
            // });
            // // cambiarEstadoPostulaciónDocumentos(nuevosdocumentos, nuevaspostulaciones);
            // let infoupdate = [...documentossubsanar];
            // for (var i in infoupdate) {
            //     infoupdate[i].documentos_administrativos = nuevosdocumentos;
            // }
            // setDocumentosSubsanar(infoupdate);
            // return setPostulacionState({ ...postulacionState, documentos_administrativos: nuevosdocumentos });
        } catch (error) {
            return console.error(error);
        }
    };

    const cambiarEstadoPostulaciónDocumentos = async () => {
        // let pBeps =postulacionesBeps["postulacionesBeps"]?postulacionesBeps["postulacionesBeps"]:postulacionesBeps;
        // let nuevaspostulaciones = pBeps.map((data: any) => {
        //     if (data.id_postulacion === postulacionState.id_postulacion) {
        //         return postulacionState;
        //     }
        //     return data;
        // });
        // await apiParticipantes.guardarDocumentosAdministrativosPostulacion(
        //     postulacionState.id_postulacion,
        //     postulacionState.documentos_administrativos
        // );
        // let estado = "Subsanado";
        // let subsanar = postulacionState.documentos_administrativos.filter((data: any) => data.checksubsanable);
        // console.log(subsanar);
        // console.log(postulacionState.documentos_administrativos);
        // if (subsanar.length > 0) estado = "Subsanar";
        // await apiParticipantes.cambiarEstadoPostulacion({
        //     id_postulacion: postulacionState.id_postulacion,
        //     estado: estado,
        // });

        // let payloadNotificacionAdmin = {
        //     tipo_notificacion: "Subsanación beps",
        //     nombre_proyecto: postulacionState.nombre_propuesta,
        //     remitente: participante.idParticipante,
        //     convocatoria_id: postulacionState.convocatoria_id
        // }

        // await apiNotificaciones.enviarNotificacionAdministrador(payloadNotificacionAdmin);

        // return setPostulacionesBeps(nuevaspostulaciones);
    };
    const cambiarCantidadPaginas = (e: any, value: any) => {
        return setCantidadPáginas(value);
    };
    const cambiarCantidadPaginasDocumentos = (e: any, value: any) => {
        return setCantidadPáginasSubsanar(value);
    }
    return {
        // postulacionesBeps,
        // setPostulacionesBeps,
        cargarPostulaciones,
        guardarArchivosAdministrativos,
        setPostulacionState,
        totalregistros,
        cantidadpáginas,
        cambiarCantidadPaginas,
        documentossubsanar,
        setDocumentosSubsanar,
        totaldocumentossubsanar,
        cantidadpáginassubsanar,
        cambiarCantidadPaginasDocumentos,
        cambiarEstadoPostulaciónDocumentos
    };
};
